import { RiDashboardHorizontalFill } from "react-icons/ri";
import {
  CommercialsIcon,
  FAQIcon,
  MyPlacesIcon,
  ProfileIcon,
  SaveIcon,
} from "./assets/designedPickedIcons";
export const contributerSidebarLinks = [
  {
    title: "dashboard",
    icon: <RiDashboardHorizontalFill size={32} />,
    link: "/",
  },
  {
    title: "myPlaces",
    icon: <MyPlacesIcon size={32} />,
    link: "/places",
  },
  {
    title: "commercials",
    icon: <CommercialsIcon size={32} />,
    link: "/commercials",
  },
  {
    title: "profile",
    icon: <ProfileIcon size={32} />,
    link: "/profile",
  },
];
export const commonLinks = [
  {
    title: "faq",
    icon: <FAQIcon size={32} />,
    link: "/faq",
  },
];
export const userLinks = [
  { title: "home", icon: <RiDashboardHorizontalFill size={32} />, link: "/" },
  { title: "saved", icon: <SaveIcon />, link: "/saved" },
  {
    title: "Discover",
    icon: <CommercialsIcon size={32} />,
    link: "/commercials",
  },
  {
    title: "profile",
    icon: <ProfileIcon size={32} />,
    link: "/profile",
  },
];
